<template>
  <term-and-condition-list
    @deleteTermAndConditionConfigurationClick="deleteTermAndConditionConfigurationClick($event)"
    @loadData="loadData($event)"
    @saveTermAndCondition="saveTermAndCondition($event)"
    :termAndConditionConfigurations="termAndConditionConfigurations"
    :termAndConditionStatesLoading="termAndConditionStatesLoading"
  ></term-and-condition-list>
</template>

<script>
import TermAndConditionList from '../../components/TermAndConditionList.vue';

export default {
  name: 'list-term-and-condition-view',
  components: { TermAndConditionList },
  data() {
    return {
      termAndConditionStatesLoading: false,
      termAndConditionConfigurations: [],
    };
  },
  methods: {
    async listTermAndConditionConfigurations({ bookingChannelId }) {
      this.termAndConditionStatesLoading = true;
      this.termAndConditionConfigurations = await this.$store.dispatch('bookingChannel/getBookingChannelTermAndConditionList', {
        bookingChannelId,
      });
      this.termAndConditionStatesLoading = false;
    },
    async deleteTermAndConditionConfiguration({ bookingChannelId, termAndConditionId }) {
      this.termAndConditionStatesLoading = true;
      const result = await this.$store.dispatch('bookingChannel/deleteBookingChannelTermAndCondition', {
        bookingChannelId,
        termAndConditionId,
      });

      if (result) {
        this.termAndConditionConfigurations = this.termAndConditionConfigurations.filter(termAndConditionConfiguration => termAndConditionConfiguration.id !== termAndConditionId);
      }

      this.termAndConditionStatesLoading = false;
    },
    async deleteTermAndConditionConfigurationClick(termAndConditionConfiguration) {
      await this.deleteTermAndConditionConfiguration({
        bookingChannelId: this.$store.state.bookingChannel.id,
        termAndConditionId: termAndConditionConfiguration.id,
      });
    },
    saveTermAndCondition(termAndConditionConfiguration) {
      this.termAndConditionConfigurations.push(termAndConditionConfiguration);
    },
    async loadData() {
      await this.listTermAndConditionConfigurations({
        bookingChannelId: this.$store.state.bookingChannel.id,
      });
    },
  },
};
</script>
